import {
  canPostalCodePattern,
  normalizeCanPostalCode,
  normalizeUsaZipCode,
} from "@homeinstead/locale";

const usaZipPattern = /^(\d{5}-\d{4}|\d{5}|\d{9})$/;

/**
 * Normalizes a NANP geo search term (US ZIP or Canadian postal code) before
 * calling hi-marketing-api office search. City/state queries pass through
 * unchanged aside from trimming.
 */
function normalizeNanpGeoSearchTerm(rawValue: string): string {
  const trimmed = rawValue.trim();
  if (!trimmed) {
    return trimmed;
  }

  if (canPostalCodePattern.test(trimmed)) {
    return normalizeCanPostalCode(trimmed);
  }

  if (usaZipPattern.test(trimmed)) {
    return normalizeUsaZipCode(trimmed);
  }

  return trimmed;
}

export { normalizeNanpGeoSearchTerm };
